import { ComponentRef, Injectable } from '@angular/core';
import {
  DialogService,
  DialogRef,
  DialogCloseResult,
  DialogResult,
} from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { ScheduleTimeComponent } from '../components/schedule-time/schedule-time.component';

@Injectable({
  providedIn: 'root',
})
export class ScheduleDialogService {
  constructor(private dialogService: DialogService) {}

  public open(): {
    result$: Observable<DialogCloseResult | DialogResult>;
    instance: ScheduleTimeComponent;
  } {
    const dialog: DialogRef = this.dialogService.open({
      content: ScheduleTimeComponent,
      height: '80vh',
      minWidth: '1166',
      width: '80vw',
      cssClass: 'schedule-meeting',
      autoFocusedElement: '.k-dialog-titlebar-action, button',
    });

    // ComponentRef<ScheduleTimeComponent>
    const content: ComponentRef<ScheduleTimeComponent> =
      dialog.content as ComponentRef<ScheduleTimeComponent>;
    const instance: ScheduleTimeComponent = content.instance;

    return {
      result$: dialog.result as Observable<DialogCloseResult | DialogResult>,
      instance,
    };
  }
}
